import React__default from 'react';
import clsx from 'clsx';
import './../../../assets/src/components/util/NoStyleButton.css.ts.vanilla-9a05fce1.css';
import './../../../assets/src/components/util/NoStyleLink.css.ts.vanilla-7b419b33.css';
import Visible from '../../util/Visible/Visible.js';
import Spacer from '../../util/Spacer/Spacer.js';
import ProgressBarContainer from '../components/ProgressBar/ProgressBarContainer.js';
import '../../buttons/index.js';
import { getRightLeftFileName, getFileIcon, formatBytes } from '../helper.js';
import './../../../assets/src/components/file-uploadV2/components/ProcessingZone/ProcessingZone.css.ts.vanilla-36b1cf63.css';
import './../../../assets/src/components/file-uploadV2/index.css.ts.vanilla-3089ae81.css';

/* eslint-disable @typescript-eslint/no-explicit-any */
const FileComponent = ({ file, hovered, progressConfig, hasFileProcessing, deleteFile, setProgress }) => {
    const { leftText, rightText, fileType } = getRightLeftFileName(file.name);
    const showCompletedFile = file.processed || (file.uploaded && !file.error && !hasFileProcessing);
    const showProgressBar = !showCompletedFile && !file.error;
    const getRightContent = () => {
        const deleteIconClass = file.isUploading ? 'icon-16-close-mono' : 'icon-16-bin-mono';
        return (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Visible, { when: !hovered },
                React__default.createElement(Visible, { when: showCompletedFile },
                    React__default.createElement("div", { className: 'c-uploader-file__right-info' }, formatBytes(file.size))),
                React__default.createElement(Visible, { when: file.error },
                    React__default.createElement("div", { className: 'c-uploader-file__name--incomplete' }, file.error)),
                React__default.createElement(Visible, { when: showProgressBar },
                    React__default.createElement("div", { className: 'c-uploader-file__right-info' }, `${progressConfig.progress}%`))),
            React__default.createElement(Visible, { when: hovered },
                React__default.createElement("span", { "data-testid": 'delete-file-icon', className: clsx(deleteIconClass, 'c-uploader-file__icon-blue'), onClick: deleteFile }))));
    };
    const getFileNameContent = () => {
        const fileNameClass = showCompletedFile ? 'c-uploader-file__name--completed' : 'c-uploader-file__name--incomplete';
        const containerClassName = `c-uploader-file__name ${fileNameClass}`;
        return (React__default.createElement("div", { className: clsx(containerClassName, hovered && `${fileNameClass}--hovered`) },
            React__default.createElement("div", { className: 'c-uploader-file__ellipsis-text' }, leftText),
            rightText));
    };
    return (React__default.createElement("div", { "data-testid": `uploaded-file-${file.id}`, className: 'c-uploader-file' },
        React__default.createElement("div", { className: 'c-uploader-file__left-info-container' },
            React__default.createElement("div", { className: 'c-uploader-file__left-info' },
                React__default.createElement("span", { className: clsx(getFileIcon(fileType), 'c-uploader-file__icon-blue'), onClick: deleteFile }),
                React__default.createElement(Spacer, { right: 14 }),
                React__default.createElement(Visible, { when: showCompletedFile },
                    React__default.createElement("span", { className: clsx('icon-checkmark-mono', 'c-uploader-file__icon-blue') }),
                    React__default.createElement(Spacer, { right: 9 })),
                React__default.createElement(Visible, { when: file.error },
                    React__default.createElement("span", { "data-testid": 'info-icon', className: clsx('icon-16-info-mono', 'c-uploader-file__icon-blue') }),
                    React__default.createElement(Spacer, { right: 9 })),
                getFileNameContent()),
            React__default.createElement(Visible, { when: showProgressBar },
                React__default.createElement(Spacer, { top: 4 }),
                React__default.createElement(ProgressBarContainer, { progressConfig: progressConfig, setProgress: setProgress }))),
        getRightContent()));
};

export { FileComponent as default };
//# sourceMappingURL=FileComponent.js.map
